import { ACTION_TYPES } from "../actions/types";

const initialState = {
  pm2Status: null,
  pm2Loading: false,
  pm2Error: null,
  pm2Restarting: false,
  lastRestartResult: null,
  lastUpdated: null,
  pm2Logs: null,
  pm2LogsLoading: false,
};

export default function pm2Reducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.GET_PM2_STATUS:
      return {
        ...state,
        pm2Status: action.payload,
        lastUpdated: new Date().getTime(),
      };

    case ACTION_TYPES.PM2_RESTART_SUCCESS:
      return {
        ...state,
        lastRestartResult: action.payload,
      };

    case ACTION_TYPES.SET_PM2_LOADING:
      return {
        ...state,
        pm2Loading: action.payload,
      };

    case ACTION_TYPES.SET_PM2_ERROR:
      return {
        ...state,
        pm2Error: action.payload,
      };

    case ACTION_TYPES.SET_PM2_RESTARTING:
      return {
        ...state,
        pm2Restarting: action.payload,
      };

    case ACTION_TYPES.GET_PM2_LOGS:
      return {
        ...state,
        pm2Logs: action.payload,
      };

    case ACTION_TYPES.SET_PM2_LOGS_LOADING:
      return {
        ...state,
        pm2LogsLoading: action.payload,
      };

    default:
      return state;
  }
}
